module.exports = __webpack_public_path__ + "img/biwaho_pc.ea8ba63f.jpg";